import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'typescript-fsa';
import { ThunkDispatch } from 'redux-thunk';
import { ClientPersistInterface } from 'Interfaces/ClientPersistInterface';
import { QuestionInterface } from 'Interfaces/Forms/QuestionInterface';
import { JSONInterface } from 'Interfaces/JsonInterface';
import { updateProgress } from 'actions';
import { ProgressInterface } from 'Interfaces/ProgressInterface';
import FileQuestion from '../elements/FileQuestion';
import FormUtils from '../utils/FormUtils';
import { LooseObject } from '../../../Interfaces/LooseObject';
import { DataPoint } from '../../../Interfaces/DataPoint';
import { StateInterface } from '../../../Interfaces/StateInterface';
import { ModalComponentNames, ModalInterface } from '../../../Interfaces/ModalInterface';
import { navigateAddModal, navigateRemoveModal } from '../../../actions/navigationAction';
import { getFileUrl, getPresignedUrl, rotateImage } from '../../../actions/file';

export interface Props {
  dataPoint: DataPoint;
  updateAnswer: (value: LooseObject) => void;
  question: QuestionInterface;
  accept: string | undefined;
  formUtils?: FormUtils;
  isSubQuestion?: boolean;
  edit: boolean;
  isTable?: boolean;
}

export interface StateProps {
  groupDiagrams: LooseObject[];
  clientPersist: ClientPersistInterface;
}

export interface ActionProps {
  navigateAddModal: (modal: ModalInterface) => void;
  navigateRemoveModal: (modal: ModalComponentNames) => void;
  getFileUrl: (fileId: string, callBack: (url: string) => void) => void;
  rotateImage: (angle: string, fileId: number, callBack: (id: number) => void) => void;
  getPresignedUrl: (args) => Promise<JSONInterface>;
  updateProgress: (progress: ProgressInterface) => void;
}

export type FileQuestionPropsInterface = Props & StateProps & ActionProps;

const FileQuestionContainer = (props: FileQuestionPropsInterface) => {
  return (
    <FileQuestion {...props} />
  );
};

const mapStateToProps = (state: StateInterface): StateProps => {
  return {
    groupDiagrams: state.groupDiagrams, // read state from parent if there?
    clientPersist: state.clientPersist,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<StateInterface, any, AnyAction>): ActionProps => {
  return {
    navigateAddModal: (modal: ModalInterface) => {
      dispatch(navigateAddModal(modal));
    },
    navigateRemoveModal: (modalName: ModalComponentNames) => {
      dispatch(navigateRemoveModal(modalName));
    },
    getFileUrl: (fileId, callBack) => {
      dispatch(getFileUrl(fileId, callBack));
    },
    rotateImage: (angle: string, fileId: number, callBack: (id: number) => void) => {
      dispatch(rotateImage(angle, fileId, callBack));
    },
    getPresignedUrl: (args) => dispatch(getPresignedUrl(args)),
    updateProgress: (progress: ProgressInterface) => dispatch(updateProgress(progress))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileQuestionContainer);
